export default {
    props: {
        className: {
            type: String,
            default: "chart"
        },
        width: {
            type: String,
            default: "100%"
        },
        height: {
            type: String,
            default: "350px"
        },
        options: {
            type: Object,
            default () {
                return {}
            }
        },
        chartData: {
            type: Array,
            required: true,
            default () {
                return []
            }
        },
        dimensions: {
            type: [Object, Array]
        }
    },
    data () {
        return {
            chart: null
        }
    },
    beforeDestroy () {
        if (this.chart) {
            this.chart.dispose()
            this.chart = null
        }
    },
    methods: {
        initChart (defaultSettings) {
            this.chart.setOption({
                dataset: {
                    dimensions: this.dimensions,
                    source: this.chartData
                },
                ...Object.merge(defaultSettings, this.options)
            })
        },
        getDataURL (option = {}) {
            option = Object.assign({}, {
                type: "png",
                pixelRatio: 1
                // excludeComponents: [] 忽略的组件
            }, option)
            return this.chart.getDataURL(option)
        }
    }
}
